import React, { useEffect, useState, useRef, lazy } from 'react';
import { TestimonialCard } from './TestimonialCard';
import { CTAButton } from './CTAButton';
import { StickyCTA } from './StickyCTA';
import { EyeIcon, CheckCircle, AlertCircle, ImageIcon } from 'lucide-react';
import { ImagePlaceholder } from './ImagePlaceholder';
export const Advertorial = () => {
  const [isScrolledPastFirstTwoSections, setIsScrolledPastFirstTwoSections] = useState(false);
  const [isAtTopSection, setIsAtTopSection] = useState(true);
  const [userCity, setUserCity] = useState('New York');
  const firstTwoSectionsRef = useRef(null);
  // Fetch user location data
  useEffect(() => {
    const fetchUserLocation = async () => {
      try {
        const response = await fetch('https://ipinfo.io/json');
        if (response.ok) {
          const data = await response.json();
          if (data.city && data.city.trim() !== '') {
            setUserCity(data.city);
            console.log(`User location detected: ${data.city}`);
          }
        }
      } catch (error) {
        console.error('Error fetching location data:', error);
        // Keep default "New York" if there's an error
      }
    };
    fetchUserLocation();
  }, []);
  useEffect(() => {
    // Set initial states
    setIsScrolledPastFirstTwoSections(false);
    setIsAtTopSection(true);
    const scrollOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -90% 0px' // Consider element as "passed" when it's 90% above the viewport
    };
    const topSectionOptions = {
      threshold: 0.3,
      rootMargin: '-100px 0px 0px 0px' // Consider top section visible when at least 30% is visible
    };
    const scrollObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        // When the section is no longer intersecting (scrolled past it)
        if (!entry.isIntersecting) {
          setIsScrolledPastFirstTwoSections(true);
        } else {
          setIsScrolledPastFirstTwoSections(false);
        }
      });
    }, scrollOptions);
    const topSectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        // When the top section is visible
        if (entry.isIntersecting) {
          setIsAtTopSection(true);
        } else {
          setIsAtTopSection(false);
        }
      });
    }, topSectionOptions);
    // Small delay to ensure DOM is fully rendered
    setTimeout(() => {
      if (firstTwoSectionsRef.current) {
        scrollObserver.observe(firstTwoSectionsRef.current);
        topSectionObserver.observe(firstTwoSectionsRef.current);
      }
    }, 100);
    return () => {
      if (firstTwoSectionsRef.current) {
        scrollObserver.unobserve(firstTwoSectionsRef.current);
        topSectionObserver.unobserve(firstTwoSectionsRef.current);
      }
    };
  }, []);
  // Log the state for debugging
  useEffect(() => {
    console.log('Scrolled past first two sections:', isScrolledPastFirstTwoSections, 'At top section:', isAtTopSection);
  }, [isScrolledPastFirstTwoSections, isAtTopSection]);
  return <div className="w-full bg-white" data-id="element-7">
      {/* Top Header Bar */}
      <div className="w-full bg-gray-900 text-white" data-id="element-8">
        <div className="container mx-auto px-4 py-2 flex justify-between items-center" data-id="element-9">
          <div className="flex items-center" data-id="element-10">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-2" data-id="element-11">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="white" data-id="element-12" />
            </svg>
            <span className="font-semibold tracking-wider" data-id="element-13">WOMEN'S HEALTH</span>
          </div>
          <div className="flex items-center" data-id="element-14">
            <div className="w-5 h-5 mr-2 rounded-full overflow-hidden" data-id="element-15">
              <svg viewBox="0 0 512 512" className="w-full h-full" data-id="element-16">
                <path fill="#f0f0f0" d="M0 85.331h512v341.337H0z" data-id="element-17" />
                <path fill="#d80027" d="M0 85.331h512v42.663H0zm0 85.337h512v42.663H0zm0 85.337h512v42.663H0zm0 85.337h512v42.663H0z" data-id="element-18" />
                <path fill="#2e52b2" d="M0 85.331h256v183.797H0z" data-id="element-19" />
                <path fill="#f0f0f0" d="M99.822 160.624L95.699 173.308H82.363L93.113 181.143L89.021 193.826L99.822 186.034L110.624 193.826L106.532 181.143L117.306 173.308H103.97z" data-id="element-20" />
                <path fill="#f0f0f0" d="M103.622 219.081l-3.284 10.134h-10.638l8.609 6.333-3.284 10.134 8.598-6.348 8.598 6.348-3.284-10.134 8.609-6.333h-10.638zM167.737 160.624l-4.123 12.684h-13.336l10.75 7.835-4.092 12.683 10.801-7.792 10.802 7.792-4.092-12.683 10.774-7.835h-13.336zM167.737 219.081l-3.284 10.134h-10.638l8.609 6.333-3.284 10.134 8.598-6.348 8.598 6.348-3.284-10.134 8.609-6.333h-10.638zM31.908 160.624l-4.123 12.684H14.449l10.75 7.835-4.092 12.683 10.801-7.792 10.802 7.792-4.092-12.683 10.774-7.835H36.031zM31.908 219.081l-3.284 10.134H17.986l8.609 6.333-3.284 10.134 8.598-6.348 8.598 6.348-3.284-10.134 8.609-6.333H35.192z" data-id="element-21" />
              </svg>
            </div>
            <span className="text-sm" data-id="element-22">Trending in the US</span>
          </div>
        </div>
      </div>
      {/* Header */}
      <header className="w-full border-b border-gray-200" data-id="element-23">
        <div className="container mx-auto px-4 py-3" data-id="element-24">
          <p className="text-xs font-semibold text-gray-500 tracking-wider" data-id="element-25">
            WOMEN'S HEALTH | Advertorial
          </p>
        </div>
      </header>
      {/* Notification Banner */}
      <div className="w-full bg-amber-50 border border-amber-200" data-id="element-26">
        <div className="container mx-auto px-4 py-3 flex items-center justify-center text-center" data-id="element-27">
          <AlertCircle className="text-red-500 mr-2 flex-shrink-0" size={20} data-id="element-28" />
          <p className="font-bold text-sm sm:text-base" data-id="element-29">
            UPDATE: Nymera LymphEase™ Is Selling Out FAST! Grab Yours NOW to
            Get 40% OFF + Fast FREE Shipping Across the US
          </p>
        </div>
      </div>
      {/* Main Content */}
      <div className="container mx-auto px-4" data-id="element-30">
        <div className="flex flex-col lg:flex-row lg:justify-center" data-id="element-31">
          {/* Main Content */}
          <main className="w-full max-w-3xl mx-auto" data-id="element-32">
            <div className="py-6 px-0 md:px-4" data-id="element-33">
              {/* Headline */}
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-4" data-id="element-34">
                Stop Spending $200 Per Session on Lymphatic Massage for Lipedema
                — Here's How to Get the Same Relief at Home, Daily
              </h1>

              {/* Subheadline */}
              <p className="text-lg md:text-xl text-gray-600 mb-6" data-id="element-35">
                Thousands of women are using a gentle fascia massage tool to
                break up 'lymphatic blockages' and finally drain trapped fluid —
                without bruising, without appointments, and for a one-time cost.
              </p>

              {/* Author and Date */}
              <div className="flex items-center justify-between border-b border-gray-200 pb-4 mb-6" data-id="element-36">
                <div className="flex items-center" data-id="element-37">
                  <p className="text-sm text-gray-700" data-id="element-38">
                    By Sarah Mitchell, Women's Health | April 29, 2025
                  </p>
                </div>
                <div className="flex items-center text-sm text-gray-500" data-id="element-39">
                  <EyeIcon size={16} className="mr-1" data-id="element-40" />
                  <span data-id="element-41">247,891</span>
                </div>
              </div>

              {/* IMAGE 1 - KEEP SAME */}
              <div className="mb-8 rounded-lg overflow-hidden" data-id="element-42">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hb7663489Vj6W5fHFmd7JR/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_21_%CF%80.%CE%BC..png" alt="Image of a woman looking exhausted and defeated while sitting on an examination table in a doctor's office, holding her swollen legs" className="w-full h-auto" data-id="element-43" />
              </div>

              {/* Opening Story */}
              <div className="mb-10" data-id="element-44">
                <p className="mb-4" data-id="element-45">
                  I'll never forget sitting in my lymphatic therapist's office,
                  writing yet another $150 check, thinking: "I can't keep doing
                  this."
                </p>
                <p className="mb-4" data-id="element-46">
                  Don't get me wrong — the Manual Lymphatic Drainage sessions
                  helped. For about two days, my legs felt lighter. Less
                  swollen. Almost normal.
                </p>
                <p className="mb-4" data-id="element-47">
                  But by day three? The heaviness came roaring back. The pain
                  returned. That awful feeling of fluid trapped in my tissue
                  with nowhere to go.
                </p>
                <p className="mb-4" data-id="element-48">
                  And then I'd have to book another appointment. Another $150.
                  Another two hours out of my week.
                </p>
                <p className="mb-4" data-id="element-49">
                  I was spending over $600 a month just to feel decent for a few
                  days at a time. My insurance wouldn't cover it. My bank
                  account was hemorrhaging. And worst of all? I felt trapped in
                  this endless cycle of temporary relief.
                </p>
                <p className="mb-4 font-semibold" data-id="element-50">Sound familiar?</p>
                <p className="mb-4" data-id="element-51">
                  If you have lipedema, you already know what I'm talking about.
                  You know that MLD works — it's one of the few things that
                  actually does. But you also know it's expensive,
                  time-consuming, and the relief disappears almost as fast as it
                  arrives.
                </p>
                <p className="mb-4" data-id="element-52">
                  What if I told you there was a way to get that same lymphatic
                  drainage relief at home, every single day, without the
                  appointments and without the massive monthly bills?
                </p>
                <p className="mb-4" data-id="element-53">
                  That's exactly what I discovered. And it changed everything.
                </p>
              </div>

              {/* The Lipedema Trap Section */}
              <div className="mb-10" ref={firstTwoSectionsRef} data-id="element-54">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-55">
                  The Lipedema Trap: Why Nothing Gives You Lasting Relief
                </h2>

                {/* IMAGE 2 - Medical Illustration */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-56">
                  <img src="https://cdn.magicpatterns.com/uploads/pN5YywrPTQZnbJoouWiTvg/ChatGPT_Image_11_Δεκ_2025,_07_08_34_μ.μ..png" alt="Medical illustration showing blocked lymphatic vessels in lipedema tissue with trapped fluid and inflammation" className="w-full h-auto" data-id="element-57" />
                </div>

                <p className="mb-4" data-id="element-58">
                  Here's what most doctors don't explain when they diagnose you
                  with lipedema:
                </p>
                <p className="mb-4" data-id="element-59">
                  Your lymphatic system — the network of vessels responsible for
                  draining excess fluid from your tissue — isn't working
                  properly in your legs. The lipedema fat creates blockages in
                  these pathways, like debris clogging a drainage pipe.
                </p>
                <p className="mb-4" data-id="element-60">
                  When fluid can't drain, it gets trapped. And when fluid stays
                  trapped, it creates:
                </p>
                <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-61">
                  <li data-id="element-62">
                    That heavy, concrete-leg feeling that gets worse as the day
                    goes on
                  </li>
                  <li data-id="element-63">Chronic pain and tenderness in your tissue</li>
                  <li data-id="element-64">
                    Progressive swelling that makes your legs look even larger
                  </li>
                  <li data-id="element-65">
                    Fibrosis and hardening as the tissue becomes more damaged
                    over time
                  </li>
                </ul>
                <p className="mb-4" data-id="element-66">
                  This is why diet doesn't work. This is why compression only
                  helps temporarily. This is why even exercise — while good for
                  you — doesn't make your legs smaller.
                </p>
                <p className="mb-4" data-id="element-67">
                  Because the fundamental problem isn't the fat itself. It's
                  that your lymphatic system can't drain the fluid that's
                  trapped in and around that fat.
                </p>
              </div>

              {/* The $7,800 Annual Problem Section */}
              <div className="mb-10" data-id="element-68">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-69">
                  The $7,800 Annual Problem (And Why I Finally Said "Enough")
                </h2>

                {/* IMAGE 3 - Calculator and Bills */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-70">
                  <img src="https://cdn.magicpatterns.com/uploads/qGyg1j6hfRTKWyzxnTtfe3/ChatGPT_Image_11_Δεκ_2025,_07_08_33_μ.μ..png" alt="Woman stressed looking at calculator showing $7,800 with medical bills spread on table" className="w-full h-auto" data-id="element-71" />
                </div>

                <p className="mb-4" data-id="element-72">
                  Let me break down what I was actually spending on lymphatic
                  drainage:
                </p>
                <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-73">
                  <li data-id="element-74">
                    $150 per MLD session (that's on the low end in my area)
                  </li>
                  <li data-id="element-75">Twice per week to maintain any kind of relief</li>
                  <li data-id="element-76">52 weeks per year</li>
                  <li data-id="element-77">
                    <strong data-id="element-78">Total: $7,800 per year.</strong> Just to manage my
                    symptoms.
                  </li>
                </ul>
                <p className="mb-4" data-id="element-79">And that's not counting:</p>
                <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-80">
                  <li data-id="element-81">The time off work for appointments</li>
                  <li data-id="element-82">The gas money driving back and forth</li>
                  <li data-id="element-83">The mental exhaustion of scheduling and rescheduling</li>
                  <li data-id="element-84">
                    The frustration when my favorite therapist was booked out
                    for weeks
                  </li>
                </ul>
                <p className="mb-4" data-id="element-85">
                  I remember sitting at my kitchen table one night, looking at
                  my credit card statement, and just crying. I felt trapped. I
                  needed the MLD to function, but I couldn't afford to keep
                  doing it.
                </p>
                <p className="mb-4" data-id="element-86">There had to be another way.</p>
              </div>

              {/* The Discovery Section */}
              <div className="mb-10" data-id="element-87">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-88">
                  The Discovery That Changed Everything
                </h2>

                {/* IMAGE 4 - Nymera Product */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-89">
                  <img src="https://cdn.magicpatterns.com/uploads/oJCSvdewyJ2VZxD5H15E9n/ChatGPT_Image_11_Δεκ_2025,_07_08_21_μ.μ..png" alt="Nymera LymphEase™ fascia massage tool - sleek white device with ergonomic design" className="w-full h-auto" data-id="element-90" />
                </div>

                <p className="mb-4" data-id="element-91">
                  I was deep in a lipedema Facebook group at 2 AM (because of
                  course I was — when your legs hurt, sleep is hard), and I saw
                  a woman post about something called a fascia massage tool
                  specifically designed for lymphatic drainage.
                </p>
                <p className="mb-4" data-id="element-92">
                  She said it was helping her move trapped fluid at home. That
                  her legs felt lighter. That she wasn't spending $600 a month
                  on MLD anymore.
                </p>
                <p className="mb-4" data-id="element-93">
                  I was skeptical. I'd seen the horror stories about aggressive
                  fascia tools like the FasciaBlaster — women covered in
                  bruises, tissue damage, swelling that got worse instead of
                  better.
                </p>
                <p className="mb-4" data-id="element-94">
                  But this was different. This tool — the Nymera LymphEase™ —
                  was specifically designed for women with lipedema.
                </p>
              </div>

              {/* How It Works Section */}
              <div className="mb-10" data-id="element-95">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-96">
                  How Nymera LymphEase™ Actually Works (Without the Medical
                  Jargon)
                </h2>

                {/* IMAGE 5 - How It Works Diagram */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-97">
                  <img src="https://cdn.magicpatterns.com/uploads/q2ESMYVg1YYZ17RKYUyoVv/ChatGPT_Image_11_Δεκ_2025,_07_08_28_μ.μ..png" alt="Diagram showing how Nymera tool's gentle wave motion helps move trapped lymphatic fluid along natural drainage pathways" className="w-full h-auto" data-id="element-98" />
                </div>

                <p className="mb-4" data-id="element-99">
                  Think about what happens during a professional MLD session:
                  Your therapist uses very light, rhythmic movements in specific
                  directions to manually push lymphatic fluid toward your lymph
                  nodes, where it can be processed and eliminated from your
                  body.
                </p>
                <p className="mb-4" data-id="element-100">
                  That's exactly what Nymera LymphEase™ does — except you
                  control it, you can use it daily, and you pay for it once
                  instead of $150 every few days.
                </p>
              </div>

              {/* Why This Works Section */}
              <div className="mb-10" data-id="element-101">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-102">
                  Why This Works When Other At-Home Tools Failed
                </h2>

                {/* IMAGE 6 - Tool Comparison */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-103">
                  <img src="https://cdn.magicpatterns.com/uploads/hK2x64QUrdQ74VVqaE6Gqa/ChatGPT_Image_11_Δεκ_2025,_07_08_23_μ.μ..png" alt="Comparison showing aggressive fascia scraping tool (wrong) vs gentle Nymera LymphEase™ approach (correct)" className="w-full h-auto" data-id="element-104" />
                </div>

                <p className="mb-4" data-id="element-105">
                  I know what you're thinking. Because I thought it too: "I've
                  tried at-home massage tools before. They either did nothing or
                  made things worse."
                </p>
                <p className="mb-4" data-id="element-106">
                  Here's why Nymera LymphEase™ is fundamentally different:
                </p>

                <div className="bg-blue-50 p-6 rounded-lg mb-6" data-id="element-107">
                  <h3 className="font-bold text-lg mb-2" data-id="element-108">
                    1. It's Designed Specifically for Lipedema Tissue
                  </h3>
                  <p className="mb-4" data-id="element-109">
                    Generic massage tools are made for cellulite, general muscle
                    tension, or athletic recovery. They're not designed for the
                    unique challenges of lipedema.
                  </p>

                  <h3 className="font-bold text-lg mb-2" data-id="element-110">
                    2. It Mimics Professional MLD Techniques
                  </h3>
                  <p className="mb-4" data-id="element-111">
                    This isn't random vibration or aggressive scraping. The wave
                    patterns and pressure are calibrated to replicate what a
                    trained MLD therapist does.
                  </p>

                  <h3 className="font-bold text-lg mb-2" data-id="element-112">
                    3. It's Gentle Enough for Daily Use
                  </h3>
                  <p className="mb-4" data-id="element-113">
                    Unlike aggressive fascia tools that cause bruising, you can
                    use Nymera LymphEase™ every single day.
                  </p>

                  <h3 className="font-bold text-lg mb-2" data-id="element-114">
                    4. It Addresses the Blockages, Not Just the Symptoms
                  </h3>
                  <p data-id="element-115">
                    Nymera LymphEase™ actually works to break up congestion and
                    fibrosis, helping to restore proper drainage over time.
                  </p>
                </div>
              </div>

              {/* What It Feels Like Section */}
              <div className="mb-10" data-id="element-116">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-117">
                  What It Actually Feels Like to Use It
                </h2>

                {/* IMAGE 7 - Woman Using Device */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-118">
                  <img src="https://cdn.magicpatterns.com/uploads/aB9MuZU1N2uLhzbFRR7oYR/ChatGPT_Image_11_Δεκ_2025,_07_08_26_μ.μ..png" alt="Woman comfortably using Nymera LymphEase™ on her leg while relaxing on couch at home" className="w-full h-auto" data-id="element-119" />
                </div>

                <p className="mb-4" data-id="element-120">
                  The first time I used my Nymera LymphEase™, I was nervous.
                  After the FasciaBlaster horror stories I'd read, I
                  half-expected pain or immediate bruising.
                </p>
                <p className="mb-4" data-id="element-121">Instead? It felt... good. Really good.</p>
                <p className="mb-4" data-id="element-122">
                  The gentle vibration combined with the smooth massage nodes
                  felt like a professional lymphatic drainage session.
                </p>
              </div>

              {/* Results Section */}
              <div className="mb-10" data-id="element-123">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-6" data-id="element-124">
                  The Results Women Are Seeing
                </h2>

                {/* IMAGE 8 - Before/After */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-125">
                  <img src="https://cdn.magicpatterns.com/uploads/uWcKgns3tu8MFmRvAUSwfN/ChatGPT_Image_11_Δεκ_2025,_07_08_30_μ.μ..png" alt="Before and after comparison showing visible reduction in leg swelling and improved shape with Nymera" className="w-full h-auto" data-id="element-126" />
                </div>

                <p className="mb-6" data-id="element-127">
                  I'm not the only one experiencing this. Thousands of women
                  with lipedema have discovered Nymera LymphEase™, and the
                  testimonials are genuinely life-changing:
                </p>

                {/* Testimonials */}
                <div className="space-y-6 mb-6" data-id="element-128">
                  <TestimonialCard quote="I was spending $200 twice a week on MLD. That's over $20,000 a year. I've been using Nymera LymphEase™ daily for two months, and I've canceled all my appointments. My legs feel just as good — maybe better, because I'm maintaining the drainage every single day instead of letting it build up between sessions." author="Michelle T." age="45" location="Denver, CO" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/3y7To7DiABw2UivqWYkvYv/images_%2842%29.jpg" data-id="element-129" />
                  <TestimonialCard quote="The difference between this and the FasciaBlaster is night and day. The FasciaBlaster left me bruised and in pain. Nymera is gentle, effective, and actually helps my legs drain. I use it every morning while I have my coffee, and by the time I'm done, my legs already feel lighter." author="Sarah W." age="39" location="Seattle, WA" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/1ZzQbxP1337U3TnJrDfMSW/istockphoto-1290775513-612x612.jpg" data-id="element-130" />
                  <TestimonialCard quote="I cried the first time I used this. Not because it hurt — because it felt GOOD. After years of painful legs and expensive massage appointments I couldn't afford, I finally have something that works and that I can use whenever I need it." author="Jessica R." age="42" location="Portland, OR" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/jA5TbK1HAopveddK7FXfLL/mockup-pretty-curvy-latin-woman-600nw-2460705183.webp" data-id="element-131" />
                </div>
              </div>

              {/* Why Nymera Works Section */}
              <div className="mb-10" data-id="element-132">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-133">
                  Why Nymera Works When Everything Else Failed
                </h2>

                <p className="mb-4" data-id="element-134">
                  Let me be very clear about something: Nymera LymphEase™ is
                  not a miracle cure. Lipedema doesn't have a cure.
                </p>
                <p className="mb-4" data-id="element-135">
                  But what it IS is a scientifically-sound,
                  therapeutically-effective tool that addresses the core problem
                  in lipedema: blocked lymphatic drainage.
                </p>
                <p className="mb-4" data-id="element-136">
                  Here's why it works when compression, diet, and even
                  occasional MLD sessions fall short:
                </p>

                <div className="space-y-6 mb-6" data-id="element-137">
                  <div className="bg-blue-50 p-6 rounded-lg" data-id="element-138">
                    <h3 className="font-bold text-lg mb-2" data-id="element-139">
                      Daily Consistency Matters
                    </h3>
                    <p data-id="element-140">
                      Your lymphatic system doesn't take days off. Fluid is
                      constantly trying to accumulate in your tissue. If you're
                      only draining it once or twice a week with professional
                      MLD, you're fighting a losing battle. Nymera allows you to
                      maintain drainage every single day. That consistency is
                      what creates lasting improvement.
                    </p>
                  </div>
                  <div className="bg-blue-50 p-6 rounded-lg" data-id="element-141">
                    <h3 className="font-bold text-lg mb-2" data-id="element-142">
                      It Addresses Fibrosis and Tissue Congestion
                    </h3>
                    <p data-id="element-143">
                      Over time, trapped fluid causes your tissue to become
                      fibrotic — thick, hard, and even more resistant to
                      drainage. Nymera's gentle massage action helps break up
                      these areas of congestion, making your tissue more
                      responsive to drainage over time.
                    </p>
                  </div>
                  <div className="bg-blue-50 p-6 rounded-lg" data-id="element-144">
                    <h3 className="font-bold text-lg mb-2" data-id="element-145">
                      It's Designed for Sensitive Tissue
                    </h3>
                    <p data-id="element-146">
                      Lipedema tissue is tender. It bruises easily. Aggressive
                      tools cause trauma that makes everything worse. Nymera is
                      specifically calibrated for the sensitivity of lipedema
                      tissue — firm enough to be effective, gentle enough to use
                      daily without damage.
                    </p>
                  </div>
                  <div className="bg-blue-50 p-6 rounded-lg" data-id="element-147">
                    <h3 className="font-bold text-lg mb-2" data-id="element-148">It Empowers You</h3>
                    <p data-id="element-149">
                      There's something psychologically powerful about being
                      able to manage your own symptoms. Instead of feeling
                      dependent on appointments and practitioners, you have a
                      tool you control. You decide when to use it. You can
                      respond to flare-ups immediately instead of waiting days
                      for an appointment.
                    </p>
                  </div>
                </div>
              </div>

              {/* Financial Reality Section */}
              <div className="mb-10" data-id="element-150">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-151">
                  The Financial Reality That Changed My Mind
                </h2>

                <p className="mb-4" data-id="element-152">
                  Let me show you the math that made this a no-brainer for me:
                </p>

                <div className="bg-red-50 p-6 rounded-lg mb-4" data-id="element-153">
                  <h3 className="font-bold text-lg mb-2" data-id="element-154">
                    Annual MLD Costs (Conservative Estimate):
                  </h3>
                  <ul className="list-disc pl-6 space-y-1" data-id="element-155">
                    <li data-id="element-156">$150 per session</li>
                    <li data-id="element-157">2 sessions per week minimum</li>
                    <li data-id="element-158">52 weeks per year</li>
                    <li className="font-bold text-red-700" data-id="element-159">
                      Total: $15,600 per year
                    </li>
                  </ul>
                </div>

                <div className="bg-green-50 p-6 rounded-lg mb-6" data-id="element-160">
                  <h3 className="font-bold text-lg mb-2" data-id="element-161">
                    Nymera LymphEase™:
                  </h3>
                  <ul className="list-disc pl-6 space-y-1" data-id="element-162">
                    <li data-id="element-163">One-time purchase</li>
                    <li data-id="element-164">Use it daily for years</li>
                    <li className="font-bold text-green-700" data-id="element-165">
                      Pays for itself in less than two weeks
                    </li>
                  </ul>
                </div>

                <p className="mb-4" data-id="element-166">
                  Even if you only see your MLD therapist once a week, you're
                  still spending $7,800 per year. For most women, Nymera pays
                  for itself within the first month.
                </p>
                <p className="mb-4" data-id="element-167">
                  And here's the thing: you don't have to completely stop your
                  MLD sessions if you don't want to. Many women (myself
                  included) now see their therapist once a month for a
                  "maintenance" session instead of multiple times per week. We
                  use Nymera daily to maintain drainage, and then get a
                  professional session periodically for that deeper work.
                </p>
                <p className="mb-4" data-id="element-168">
                  The savings are massive. The convenience is life-changing. And
                  the relief is consistent instead of temporary.
                </p>
              </div>

              {/* FasciaBlaster Section */}
              <div className="mb-10" data-id="element-169">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-170">
                  Addressing the Elephant in the Room: The FasciaBlaster
                </h2>

                <p className="mb-4" data-id="element-171">
                  I know some of you are thinking: "But what about the
                  FasciaBlaster? I've heard horror stories."
                </p>
                <p className="mb-4" data-id="element-172">
                  You should be cautious. Those horror stories are real.
                </p>
                <p className="mb-4" data-id="element-173">
                  The FasciaBlaster uses aggressive, hard plastic claws that are
                  designed to "break up" fascia with significant force. The
                  inventor literally marketed bruising as a sign it was
                  "working." Women ended up covered in severe bruises, with
                  damaged tissue, and in some cases, worsening symptoms.
                </p>
                <p className="mb-4" data-id="element-174">
                  Nymera LymphEase™ is the complete opposite approach.
                </p>
                <p className="mb-4" data-id="element-175">
                  There is no aggressive scraping. No expectation of bruising.
                  No "no pain, no gain" mentality.
                </p>
                <p className="mb-4" data-id="element-176">
                  Instead, Nymera uses the principles of Manual Lymphatic
                  Drainage — which is universally recognized as the gold
                  standard for managing lipedema. MLD is gentle. It's
                  therapeutic. It's science-based.
                </p>
                <p className="mb-4" data-id="element-177">
                  That's what Nymera replicates. Not aggressive tissue trauma,
                  but gentle, effective lymphatic stimulation.
                </p>
                <p className="mb-4" data-id="element-178">
                  You should not bruise from using Nymera. If you do, you're
                  pressing too hard, and the instructions specifically guide you
                  on proper pressure.
                </p>
                <p className="mb-4" data-id="element-179">
                  This is a tool designed by people who understand lipedema, not
                  by someone trying to sell you on "blasting" your body into
                  submission.
                </p>
              </div>

              {/* Therapist Section */}
              <div className="mb-10" data-id="element-180">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-181">
                  What Your Lymphatic Therapist Probably Won't Tell You
                </h2>

                <p className="mb-4" data-id="element-182">
                  Here's something that might surprise you: several lymphatic
                  therapists have actually started recommending Nymera
                  LymphEase™ to their clients.
                </p>
                <p className="mb-4" data-id="element-183">
                  Why would they do that? Aren't they losing business?
                </p>
                <p className="mb-4" data-id="element-184">
                  The good ones understand something important: their clients
                  can't afford to come in as often as they actually need to.
                </p>
                <p className="mb-4" data-id="element-185">
                  A responsible MLD therapist knows that lipedema patients need
                  daily lymphatic support to truly manage their symptoms. But at
                  $100-$200 per session, that's financially impossible for most
                  people.
                </p>
                <p className="mb-4" data-id="element-186">
                  So they end up seeing you once a week, or twice a week if you
                  can swing it, knowing that it's not really enough. They watch
                  you struggle between sessions. They see the fluid build back
                  up. They know you're not getting the consistent care you need.
                </p>
                <p className="mb-4" data-id="element-187">
                  The best therapists recognize that a high-quality at-home tool
                  like Nymera isn't competition — it's a complement to their
                  work. It allows their clients to maintain drainage between
                  professional sessions, which actually makes the professional
                  sessions MORE effective when you do come in.
                </p>
                <p className="mb-4" data-id="element-188">
                  My own lymphatic therapist was the one who told me about
                  Nymera. She said, "I'd rather see you once a month and have
                  you managing your drainage daily at home than have you come in
                  twice a week and struggle the other five days."
                </p>
                <p className="mb-4" data-id="element-189">
                  That's the kind of practitioner who actually cares about your
                  outcomes, not just their appointment book.
                </p>
              </div>

              {/* First CTA Section */}
              <div className="mb-10 bg-gray-100 p-6 rounded-lg" data-id="element-190">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-191">
                  This Is Your Chance to Finally Get Consistent Relief
                </h2>

                <p className="mb-4" data-id="element-192">
                  Here's what I want you to understand: you don't have to keep
                  living with constant swelling and pain.
                </p>
                <p className="mb-4" data-id="element-193">
                  You don't have to keep spending thousands of dollars a year on
                  temporary relief.
                </p>
                <p className="mb-4" data-id="element-194">
                  You don't have to feel trapped in a body that won't cooperate
                  no matter how hard you try.
                </p>
                <p className="mb-4" data-id="element-195">
                  Nymera LymphEase™ isn't going to cure your lipedema. Nothing
                  will. But it CAN give you:
                </p>
                <ul className="list-none space-y-2 mb-6" data-id="element-196">
                  <li className="flex items-start" data-id="element-197">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-198" />
                    <span data-id="element-199">
                      Daily lymphatic drainage support that actually works
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-200">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-201" />
                    <span data-id="element-202">
                      Reduced swelling and that heavy, painful feeling
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-203">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-204" />
                    <span data-id="element-205">Consistent relief instead of temporary fixes</span>
                  </li>
                  <li className="flex items-start" data-id="element-206">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-207" />
                    <span data-id="element-208">Thousands of dollars saved on MLD appointments</span>
                  </li>
                  <li className="flex items-start" data-id="element-209">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-210" />
                    <span data-id="element-211">
                      The freedom to manage your symptoms on your own schedule
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-212">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-213" />
                    <span data-id="element-214">
                      Gentle, safe treatment designed specifically for lipedema
                      tissue
                    </span>
                  </li>
                </ul>
                <p className="mb-4" data-id="element-215">
                  And right now, Nymera is offering first-time customers 40% off
                  their order.
                </p>
                <p className="mb-4" data-id="element-216">
                  This isn't a permanent discount. It's designed to help women
                  who've been spending hundreds or thousands on MLD finally
                  access an affordable, effective alternative.
                </p>
                <p className="mb-4" data-id="element-217">
                  But here's the reality: Nymera LymphEase™ sells out
                  regularly.
                </p>
                <p className="mb-4" data-id="element-218">
                  Because of the specialized design and the lipedema-specific
                  engineering, they can only produce limited quantities. When
                  word spreads that there's finally a safe, effective at-home
                  drainage tool that actually works, inventory disappears within
                  days.
                </p>
                <p className="mb-4" data-id="element-219">
                  And when they're sold out, you'll have to wait weeks or even
                  months for the next production run.
                </p>
              </div>

              {/* You Deserve Relief Section */}
              <div className="mb-10" data-id="element-220">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-221">
                  You Deserve Relief That Doesn't Break the Bank
                </h2>

                <p className="mb-4" data-id="element-222">
                  I want you to imagine something for a moment.
                </p>
                <p className="mb-4" data-id="element-223">
                  Imagine waking up tomorrow and using your Nymera LymphEase™
                  for just 10 minutes while you have your morning coffee.
                </p>
                <p className="mb-4" data-id="element-224">
                  Imagine feeling that trapped fluid start to move. That
                  pressure start to release. That heavy feeling start to lift.
                </p>
                <p className="mb-4" data-id="element-225">
                  Imagine going through your entire day without constantly
                  thinking about your legs. Without the pain. Without the
                  swelling getting progressively worse as the hours pass.
                </p>
                <p className="mb-4" data-id="element-226">
                  Imagine looking at your bank account at the end of the month
                  and seeing hundreds of dollars that you didn't spend on MLD
                  appointments — because you're managing your drainage at home,
                  effectively, every single day.
                </p>
                <p className="mb-4" data-id="element-227">
                  Imagine traveling without fear. Working without constantly
                  needing to sit and elevate. Living without the constant
                  background noise of pain and discomfort.
                </p>
                <p className="mb-4" data-id="element-228">That's what Nymera gave me.</p>
                <p className="mb-4" data-id="element-229">And that's what it can give you.</p>
              </div>

              {/* 30-Day Promise Section */}
              <div className="mb-10" data-id="element-230">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-231">
                  The 30-Day Promise
                </h2>

                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-232">
                  <img src="https://cdn.magicpatterns.com/uploads/779QnKW7bXvkZ9CQx41kk5/Ανωνυμο_σχεδιο_(55).png" alt="Nymera LymphEase™ 30-day money-back guarantee with free shipping - trusted by women across the USA" className="w-full h-auto" data-id="element-233" />
                </div>

                <p className="mb-4" data-id="element-234">
                  Look, I get it. You've been burned before. You've spent money
                  on things that didn't work. You're skeptical.
                </p>
                <p className="mb-4" data-id="element-235">
                  That's why Nymera offers a 30-day money-back guarantee.
                </p>
                <p className="mb-4" data-id="element-236">
                  Try it for a full month. Use it daily. See if your legs feel
                  lighter, less swollen, less painful. See if you can reduce or
                  eliminate your expensive MLD appointments. See if it works for
                  YOUR body and YOUR lipedema.
                </p>
                <p className="mb-4" data-id="element-237">
                  If it doesn't? Send it back for a full refund. No questions
                  asked.
                </p>
                <p className="mb-4" data-id="element-238">
                  You have nothing to lose — except the constant swelling, pain,
                  and massive monthly bills for temporary relief.
                </p>
              </div>

              {/* Final CTA Section */}
              <div className="mb-10" data-id="element-239">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-240">
                  Don't Let Another Month of Pain and Expenses Go By
                </h2>

                <p className="mb-4" data-id="element-241">Every day you wait is another day of:</p>
                <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-242">
                  <li data-id="element-243">Fluid building up in your tissue</li>
                  <li data-id="element-244">Pain and heaviness that could be relieved</li>
                  <li data-id="element-245">
                    Money spent on expensive appointments when there's a better
                    option
                  </li>
                  <li data-id="element-246">Living in discomfort when relief is available</li>
                </ul>

                <p className="mb-4" data-id="element-247">
                  You've already tried diet. You've tried exercise. You've tried
                  compression. You know that MLD works — but you also know you
                  can't afford to do it as often as you need to.
                </p>
                <p className="mb-4" data-id="element-248">Now there's another option.</p>
                <p className="mb-4" data-id="element-249">An option that's:</p>
                <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-250">
                  <li data-id="element-251">Designed specifically for lipedema</li>
                  <li data-id="element-252">Gentle enough for daily use</li>
                  <li data-id="element-253">
                    Effective enough to replace or dramatically reduce MLD
                    sessions
                  </li>
                  <li data-id="element-254">Affordable enough to pay for itself in weeks</li>
                  <li data-id="element-255">Backed by a 30-day money-back guarantee</li>
                </ul>
                <p className="mb-4" data-id="element-256">
                  The question isn't whether Nymera LymphEase™ works. Thousands
                  of women have already proven that it does.
                </p>
                <p className="mb-4" data-id="element-257">
                  The question is: Are you ready to finally get consistent
                  relief?
                </p>
                <p className="mb-4" data-id="element-258">
                  Your legs deserve relief. And you deserve to feel confident
                  and comfortable in your own body again.
                </p>
              </div>
            </div>
          </main>
          {/* Right-side CTA - Always visible on desktop */}
          <aside className="hidden lg:block lg:w-80 lg:ml-8 lg:flex-shrink-0 mt-6" data-id="element-259">
            <div className="sticky top-6" data-id="element-260">
              <StickyCTA showNewImage={true} data-id="element-261" />
            </div>
          </aside>
        </div>
      </div>
      {/* Sticky CTA - Always visible at the bottom */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-3 z-50" data-id="element-262">
        <a href="https://trynymera.com/pages/nymera-lymphase#te-featured-product" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg shadow-md transition-all w-full uppercase tracking-wider text-center block" data-id="element-263">
          GET 40% OFF NYMERA LYMPHEASE™ NOW!
        </a>
      </div>
      {/* Special Offer Banner */}
      <div className="w-full bg-red-50 border-y border-red-200" data-id="element-264">
        <div className="container mx-auto px-4 py-6" data-id="element-265">
          <div className="flex flex-col sm:flex-row items-center justify-center text-center gap-4" data-id="element-266">
            <div className="flex items-center" data-id="element-267">
              <AlertCircle className="text-red-500 mr-2 flex-shrink-0" size={24} data-id="element-268" />
              <p className="font-bold text-lg" data-id="element-269">SPECIAL OFFER:</p>
            </div>
            <p className="font-bold text-red-700 text-lg px-4" data-id="element-270">
              Get Nymera LymphEase™ at 40% OFF + FREE Shipping for a Limited
              Time!
            </p>
            <a href="https://trynymera.com/pages/nymera-lymphase#te-featured-product" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg text-base whitespace-nowrap inline-block" data-id="element-271">
              CLAIM OFFER
            </a>
          </div>
        </div>
      </div>
      {/* Disclaimer */}
      <footer className="w-full bg-gray-100" data-id="element-272">
        <div className="container mx-auto px-4 py-6 max-w-4xl" data-id="element-273">
          <div className="text-xs text-gray-500 pt-6 mb-8" data-id="element-274">
            <p className="mb-2" data-id="element-275">
              This is an advertisement and not an actual news article, blog, or
              consumer protection update. Individual results may vary.
            </p>
            <div className="flex flex-wrap space-x-2 mb-2" data-id="element-276">
              <span data-id="element-277">About Us</span>
              <span data-id="element-278">|</span>
              <span data-id="element-279">Terms of Use</span>
              <span data-id="element-280">|</span>
              <span data-id="element-281">Privacy Policy</span>
            </div>
            <p className="mb-2" data-id="element-282">
              Trademarks utilized on our website belong to their respective
              owners and no implied or expressed endorsement of our website or
              services is intended. Through in-depth research and experienced
              editors we provide feedback about products and services. We are
              independently owned, and opinions expressed here are our own. This
              website is an independent professional comparison and review site
              supported by referral fees from the sites and products featured.
            </p>
            <p data-id="element-283">©2025 Women's Health Insights. All Rights Reserved.</p>
          </div>
        </div>
      </footer>
    </div>;
};